import { ModuleRegistry } from 'react-module-container';
import { WIDGET_ID } from '../../lazy/config';
import { RootWrapper } from './root-wrapper';

ModuleRegistry.registerComponent(WIDGET_ID, () => RootWrapper);
